import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../../../components/ui/IconButton";
import { Modal } from "../../../../../../../components/ui/Modal";
import AddFabrication from "./AddFabrication";
import DeleteFabrication from "./DeleteFabrication";

const Actions = props => {
  const { id, values, artworkId } = props;

  const editModalProps = {
    body: AddFabrication,
    hideCloseButton: true,
    scale: "md",
    values,
    artworkId,
  };

  const deleteModalProps = {
    body: DeleteFabrication,
    description: "Are you sure?",
    hideCloseButton: true,
    scale: "sm",
    closeOnBackdrop: false,
    id,
  };

  if (!id) {
    return null;
  }

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        <Modal {...editModalProps}>
          <IconButton variant="clean" title="Edit Fabrication">
            <PencilIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
          </IconButton>
        </Modal>
        <Modal {...deleteModalProps}>
          <IconButton variant="clean" title="Delete Fabrication">
            <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
          </IconButton>
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
